module.exports = __webpack_public_path__ + "img/音符.8cda915b.png";